import { HrmRequestFormResponse } from '@Types/api/form';
import { RequestListSearchResponse } from '@Types/api/requestList';
import { parseDateTime } from '@Utils/transformDateTime';
import { TypeDict } from '@Types/index';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';

import { ColumnDataType } from './type';
import { getAttendanceLabel } from '../utils/getAttendanceLabel';

export const dataSourceMap = (
  data: RequestListSearchResponse<HrmRequestFormResponse>,
  findStatus: (statusNum: number) => TypeDict | undefined,
  findWorkShiftLabel: (workShift: number) => TypeDict | undefined
): Array<ColumnDataType> => {
  if (!data?.content) return [];

  return data?.content?.map((requestItem) => ({
    key: requestItem.requestId,
    requestNo: requestItem.requestId,
    empName: requestItem.empName,
    approverName: requestItem.approverName,
    workShift:
      findWorkShiftLabel(requestItem.ticketRequired)?.codeDesc ||
      EMPTY_FIELD_PLACEHOLDER,
    returnDate: parseDateTime(requestItem.startDate),
    attendance:
      getAttendanceLabel(requestItem.destination) || EMPTY_FIELD_PLACEHOLDER,
    remarks: requestItem.remarks || EMPTY_FIELD_PLACEHOLDER,
    currentLocation: requestItem.currentLocation || EMPTY_FIELD_PLACEHOLDER,
    status: findStatus(requestItem.reqStatusId)?.codeDesc || '',
  }));
};
